import { defineComponent as _defineComponent } from 'vue';
import ObjectStoreSelectButton from "@/components/ObjectStore/ObjectStoreSelectButton.vue";
import ObjectStoreSelectButtonDescribePopover from "@/components/ObjectStore/ObjectStoreSelectButtonDescribePopover.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ObjectStoreSelect',
    props: {
        objectStores: null
    },
    emits: ["select"],
    setup(__props, { emit }) {
        const toWhat = "Datasets will be filtered to those stored in";
        return { __sfc: true, emit, toWhat, ObjectStoreSelectButton, ObjectStoreSelectButtonDescribePopover };
    }
});
